import { useEffect, useState } from "react";

const links = [
  { href: "#trending", label: "今日热榜" },
  { href: "#timeline", label: "事件时间线" },
  { href: "#categories", label: "主题分类" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0] shadow-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg font-black text-background-50">
            瓜
          </span>
          <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
            吃瓜时间线
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅瓜讯
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            className="flex h-10 w-10 items-center justify-center rounded-xl bg-background-200/70 text-foreground-800 md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-200/70"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-2 block whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-bold text-background-50"
          >
            订阅瓜讯
          </a>
        </div>
      )}
    </header>
  );
}